export default __webpack_public_path__ + "static/media/chip-color.eeb15be2.png";